module.exports = __webpack_public_path__ + "download/static/img/logo.a897e598.png";